import {Pipe, PipeTransform} from '@angular/core';
import {DATE_FORMAT} from '@emma-labs/shared/typescript';
import dayjs from 'dayjs';

@Pipe({
  name: 'emDate',
})
export class EmDatePipe implements PipeTransform {
  transform(value: string, isUtc = false, ...args: any[]): string {
    return dayjs(value, {utc: isUtc}).format(DATE_FORMAT);
  }
}
